/**
 * Consumer (app) namespace support (refactor_plan A.3 / C.1).
 *
 * Storage keys become `{appId}/{libraryId (speaker)}/{label}`. The default
 * app id preserves the existing Beatbox Hero records so current users lose
 * nothing (the IndexedDB migration in db.ts maps un-namespaced records into
 * this default app namespace).
 */
export const DEFAULT_APP_ID = "beatbox-hero";
let activeAppId = DEFAULT_APP_ID;
export function setActiveAppId(appId) {
    activeAppId = appId && appId.trim().length > 0 ? appId.trim() : DEFAULT_APP_ID;
    console.info(`[namespace] active app id set to '${activeAppId}'`);
}
export function getActiveAppId() {
    return activeAppId;
}
/**
 * Prefix a storage key with the active app namespace. The default app id maps
 * to the bare key so pre-namespacing records (migrated into the default app)
 * continue to resolve unchanged.
 */
export function appScopedKey(key, appId = activeAppId) {
    if (appId === DEFAULT_APP_ID)
        return key;
    return `${appId}//${key}`;
}
